import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Nav from './Nav';
import AsideMovil from './AsideMovil';
import Carrito from './Carrito';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const uniqueCount = useSelector((state) => state.cart.cart.length);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 transition-shadow duration-300 ${scrolled ? 'shadow-xl shadow-black/30' : ''}`}>
      {/* Barra informativa superior */}
      <div className="hidden lg:flex items-center justify-center bg-[#00BEE7] text-[#0f274b] text-[13px] font-bold py-2 px-5 gap-5 tracking-[0.005em]">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        <span>contacto@atst.cl</span>
        <span className="opacity-45">|</span>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>Lun–Vie 9:00–18:00 hrs.</span>
      </div>

      {/* Barra principal */}
      <div className="bg-[#0f274b] border-b border-blue-900/60">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center h-14 md:h-20 shrink-0" aria-label="ATST Radiocomunicaciones - Inicio">
            <img
              src="https://dps2wxsijib8x.cloudfront.net/atst/LOGO-ATST.png"
              className="h-full w-auto object-contain brightness-0 invert"
              alt="ATST Radiocomunicaciones"
              width="190"
              height="72"
            />
          </Link>

          {/* Nav + CTA desktop */}
          <div className="flex items-center gap-4">
            <div className="hidden xl:block">
              <Nav />
            </div>
            <div className="hidden xl:flex items-center gap-3 ml-2">
              <Link
                to="/cotizaciones"
                className="group flex items-center gap-3 pl-6 pr-4 py-2.5 rounded-full whitespace-nowrap text-[#07263f] font-black tracking-tight bg-gradient-to-r from-[#24d8ff] via-[#00BEE7] to-[#00a8cf] border border-[#8deeff]/70 transition-all duration-200 hover:from-[#18cffb] hover:to-[#009ec4]"
              >
                <span className="relative text-[15px]">Cotizar ahora</span>
                <span className="relative w-px h-4 bg-[#0f274b]/25 shrink-0" />
                <span className="relative flex items-center justify-center shrink-0 h-8 w-8 rounded-full bg-[#0d3656]/10 ring-1 ring-[#0d3656]/20">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                  </svg>
                  {uniqueCount > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 bg-[#0f274b] text-white rounded-full h-5 min-w-5 px-1 flex items-center justify-center font-black text-[10px] leading-none shadow-md shadow-[#0f274b]/40">
                      {uniqueCount > 9 ? '9+' : uniqueCount}
                    </span>
                  )}
                </span>
              </Link>
            </div>

            {/* Mobile */}
            <div className="flex xl:hidden items-center gap-2">
              <Carrito />
              <AsideMovil />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
